import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

const getEnvironmentFromSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  return parts[0];  
};

Sentry.init({
  dsn: 'https://f00769114fc72feb610e6e34cdfbed8b@o4508661293056000.ingest.us.sentry.io/4508773953699841',
  enabled:
    process.env.NODE_ENV === 'production' &&
    import.meta.env.VITE_ENABLE_SENTRY_LOGGING === 'true',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  environment: getEnvironmentFromSubdomain(),

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  replaysOnErrorSampleRate:0,
  replaysSessionSampleRate: 0,
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/.*acescholarships\.org/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
})
